/**
 * Whether guests may create an account. A site behind login (`requireLogin`)
 * allows it only through the approval flow (`b2bAccess`); otherwise sign-up
 * would let anyone through the gate. The server refuses it the same way.
 */
export const isSignUpOpen = ({
	requireLogin,
	b2bAccess
}: {
	requireLogin?: boolean;
	b2bAccess?: boolean;
}): boolean => !requireLogin || Boolean(b2bAccess);
